import { render, staticRenderFns } from "./ProcessTypes.vue?vue&type=template&id=2f974c06"
import script from "./ProcessTypes.vue?vue&type=script&lang=js"
export * from "./ProcessTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports